export default __webpack_public_path__ + "static/media/1.0169dabc.jpg";